/** Retour immédiat au scan, l'œil étant sur le rayon : un bip et une vibration. */
const beep = (frequency: number, duration: number): void => {
  try {
    const context = new AudioContext();
    const oscillator = context.createOscillator();
    oscillator.frequency.value = frequency;
    oscillator.connect(context.destination);
    oscillator.start();
    oscillator.stop(context.currentTime + duration);
    oscillator.onended = () => void context.close();
  } catch {
    // Le retour sonore reste facultatif.
  }
};

export const scanSucceeded = (): void => {
  beep(1200, 0.08);
  navigator.vibrate?.(40);
};

export const scanFailed = (): void => {
  beep(300, 0.25);
  navigator.vibrate?.([80, 60, 80]);
};

/** Code ignoré ou non produit : bip neutre et court, sans alarme. */
export const scanNeutral = (): void => {
  beep(700, 0.06);
  navigator.vibrate?.(20);
};
